import React from 'react';
import { Field, getIn } from 'formik';
import { ErrorText } from './style';

const Error = ({ name }) => (
  <Field
    name={name}
    render={({ form: { touched, errors } }) => {
      return getIn(touched, name) && getIn(errors, name) ? (
        <ErrorText>{getIn(errors, name)}</ErrorText>
      ) : null;
    }}
  />
);

export default Error;



// WEBPACK FOOTER //
// ../shop_main/components/orderformwizard/validationError.js